"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtoZMenus = void 0;
var AtoZ = (function () {
    function AtoZ(_a) {
        var _this = this;
        var items = _a.items, target = _a.target;
        var _b;
        this.split = {
            abc: [],
            def: [],
            ghijkl: [],
            mno: [],
            pqrstuvwxyz: [],
        };
        this.misc = [];
        var menu = document.createElement("div");
        target.parentNode.insertBefore(menu, target.nextSibling);
        items.forEach(function (item) {
            var title = item.title;
            var letter = title[0].toLowerCase();
            for (var letters in _this.split) {
                if (letters.includes(letter)) {
                    _this.split[letters].push(item);
                    return;
                }
            }
            _this.misc.push(item);
        });
        this.split = __assign(__assign({}, this.split), { misc: this.misc });
        for (var letters in this.split) {
            if (!this.split[letters].length) {
                delete this.split[letters];
            }
        }
        this.dropPanels = document.createElement("div");
        this.dropPanels.classList.add("a-z-drop-panels");
        this.dropLinks = document.createElement("ul");
        this.dropLinks.classList.add("a-z-categories");
        var i = 0;
        var _loop_1 = function (letters) {
            var dropLinkLi = document.createElement("li");
            var dropLinkA = document.createElement("a");
            dropLinkA.href = "#";
            dropLinkA.classList.add("a-z-drop-link");
            if (letters === "misc") {
                dropLinkA.innerHTML = "0-9";
            }
            else {
                dropLinkA.innerHTML = letters[0].toUpperCase() + "-" + letters[letters.length - 1].toUpperCase();
            }
            dropLinkLi.appendChild(dropLinkA);
            this_1.dropLinks.appendChild(dropLinkLi);
            var dropPanel = document.createElement("div");
            dropPanel.classList.add("a-z-drop-panel");
            dropPanel.innerHTML = "\n        <ul class=\"a-z-nav\" data-a-z-level=\"1\">\n          " + ((_b = this_1.split[letters]) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                var title = _a.title, url = _a.url, categoriesSub = _a.categoriesSub;
                return "\n            <li class=\"a-z-item\" data-a-z-level=\"1\">\n              <a class=\"a-z-link\" data-a-z-level=\"1\" href=\"" + url + "\">" + title + "</a>\n              " + ((categoriesSub === null || categoriesSub === void 0 ? void 0 : categoriesSub.length) > 0
                    ? "<ul class=\"a-z-nav\" data-a-z-level=\"2\">\n                " + (categoriesSub === null || categoriesSub === void 0 ? void 0 : categoriesSub.map(function (c) { return "\n                    <li class=\"a-z-item\" data-a-z-level=\"2\">\n                      <a class=\"a-z-link\" data-a-z-level=\"2\" href=\"" + c.url + "\">" + c.title + "</a>\n                    </li>"; }).join("\n")) + "\n              </ul>"
                    : "") + "\n            </li>";
            }).join("\n")) + "\n        </ul>";
            this_1.dropPanels.appendChild(dropPanel);
            var activateDropdown = function (target) {
                Array.from(_this.dropPanels.children).forEach(function (panel) {
                    panel.classList.remove("active");
                });
                dropPanel.classList.add("active");
                Array.from(_this.dropLinks.children).forEach(function (linkLi) {
                    linkLi.querySelector("a").classList.remove("active");
                });
                target.classList.add("active");
            };
            dropLinkA.addEventListener("click", function (e) {
                e.preventDefault();
                activateDropdown(e.target);
            });
            if (i === 0) {
                activateDropdown(dropLinkA);
            }
            i++;
        };
        var this_1 = this;
        for (var letters in this.split) {
            _loop_1(letters);
        }
        menu.innerHTML = "";
        menu.classList.add("a-z-menu-inner");
        menu.appendChild(this.dropLinks);
        menu.after(this.dropPanels);
        menu.parentElement.classList.add("a-z");
    }
    return AtoZ;
}());
var AtoZMenus = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.selector, selector = _c === void 0 ? "[data-a-z-menu]" : _c;
    var menuScripts = document.querySelectorAll(selector);
    var aToZs = [];
    menuScripts &&
        menuScripts.forEach(function (script) {
            var items = JSON.parse(script.textContent.replace(/\,(?!\s*?[\{\[\"\'\w])/g, ""));
            aToZs.push(new AtoZ({ target: script, items: items }));
        });
    return aToZs;
};
exports.AtoZMenus = AtoZMenus;
